import React, { CSSProperties } from 'react';
import Character from "./Character";
import { Avatar, makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { SpriteDefine } from './SpriteManager';
import Rating from '@material-ui/lab/Rating';
import { useTranslation } from "react-i18next"

import  * as Lambda from "../../Lambda";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        position: "relative",
    },
    top: {
        position: "absolute",
        top:0,
        left:0,
        right: 0,
    },
    label: {
        backgroundColor: "#ffffffaa",
        padding: theme.spacing(1),
        display: "flex",
        alignItems: "center",
    },
    text: {
        marginLeft: theme.spacing(1),
        width: 0,
        flexGrow: 1,
    },
    avatar: {
        backgroundColor: red[500],
    },
    status: {
        padding: 8,
    },
    bottom: {
        position: "absolute",
        bottom:0,
        left:0,
        right: 0,
        alignItems: "center",
    },
    comment: {
        padding: theme.spacing(1),
        backgroundColor: "#ffffffaa",
        height: "3em",
    },
    oneline: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
  }),
);


interface Props {
    member?: Lambda.MemberType | undefined
    sprite?: SpriteDefine | undefined
    size?: string
}

function CharGrid(props: Props) {

    const classes = useStyles()
    const [t] = useTranslation()

    const styles: {[key:string]:{[key:string]:CSSProperties}} = {
        small: {
            root: { 
                width: 192,
                height: 192,
            },
            avatar: { 
                width: 32,
                height: 32, 
            }
        },
        medium: {
            root: { 
                width: 256,
                height: 256,
            },
            avatar: { 
                width: 40,
                height: 40, 
            }
        },
        large: {
            root: { 
                width: 320,
                height: 320,
            },
            avatar: { 
                width: 48,
                height: 48, 
            }
        }
    }

    return props.member?.join ? (
        <div className={classes.root} style={styles[props.size || "medium"]?.root}>
            <Character 
                sprite={props.sprite}
                character={props?.member.avatar}
            />
            <div className={classes.top}>
                <div className={classes.label}>
                    <Avatar 
                        className={classes.avatar} style={styles[props.size || "medium"]?.avatar}
                        src={props.member?.icon?.get}
                    >
                        {props?.member.name.slice(0,1)}
                    </Avatar>
                    <div className={classes.text}>
                        <Typography variant="body1" component="p" className={classes.oneline}>
                            {props?.member.name}&nbsp;
                        </Typography>                
                        <Typography variant="body2" component="p" className={classes.oneline}>
                            {props?.member.comment}&nbsp;
                        </Typography>
                    </div>
                </div>
                <div className={classes.status}>
                    <Typography variant="body2" component="p">
                        {t(`status.${props?.member.status}`)}&nbsp;
                    </Typography>
                </div>
            </div>
            <div className={classes.bottom}>
                <Rating
                    value={props?.member.busyness}
                    precision={0.5}
                    readOnly
                />
            </div>

        </div>
    ) : (
        <div className={classes.root} style={styles[props.size || "medium"]?.root}>
            <Character 
                sprite={props.sprite}
            />
            <div className={classes.top}>
                <div className={classes.label}>
                    <Avatar 
                        className={classes.avatar} style={styles[props.size || "medium"]?.avatar}
                    />                
                    <div className={classes.text}>
                        <Typography variant="body1" component="p">
                            {props?.member?.email}&nbsp;
                        </Typography>                
                        <Typography variant="body2" component="p">
                            {t("status.invite")}
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CharGrid